export class User {
  user_id: number;
  user_role_id: number;
  user_city_id: number;
  user_role_name: string;
  user_city_name: string;
  user_name: string;
  user_mobile_number: string;
  phone_uuid: string;
  user_access_token: string;
  user_password: string;

  constructor(value: any = {}) {
    Object.assign(this, value);
  }
}
